export const wordCount = string =>
  (string.replace(/['";:,.?¿\-!¡]+/g, '').match(/\S+/g) || []).length

export const getDateStamps = (updateOnly = false) => {
  const now = Math.round(new Date().getTime() / 1000)
  return updateOnly
    ? { updatedAt: now }
    : {
        createdAt: now,
        updatedAt: now,
      }
}

export const objectGet = (obj, path) => {
  if (typeof path === 'number') path = [path]
  if (typeof path === 'string') return objectGet(obj, path.split('.'))
  if (path.length === 0) return obj
  if (path.length === 1) return obj[path[0]]
  return objectGet(obj[path[0]], path.slice(1))
}

export const objectSet = (obj, path, value) => {
  if (typeof path === 'number') path = [path]
  if (typeof path === 'string') return objectSet(obj, path.split('.'), value)
  if (path.length === 0) return
  if (path.length === 1) {
    obj[path[0]] = value
    return
  }
  return objectSet(obj[path[0]], path.slice(1), value)
}
